const React = require('react');
require('./dish-guid.scss');
const guidFunction = require('../../asset/images/guid-function.svg');
const guidAdd = require('../../asset/images/guid-add.svg');
const guidBeil = require('../../asset/images/guid-beil.svg');
const guidCar = require('../../asset/images/guid-car.svg');
const guidArrow = require('../../asset/images/guid-arrow.svg');
const guidNext = require('../../asset/images/guid/guid-next.svg');
const guidDish = require('../../asset/images/dish_img_default.svg');
const guidTxt1_ = require('../../asset/images/guid/guid-txt1.svg');
const guidTxt8_ = require('../../asset/images/guid/guid-txt8.svg');
const guidTxt7_ = require('../../asset/images/guid/guid-txt7.svg');
const guidTxt6_ = require('../../asset/images/guid/guid-txt6.svg');
const guidTxt4_ = require('../../asset/images/guid/guid-txt4.svg');
const guidFunction_ = require('../../asset/images/guid/guid-txtFun.svg');
const guidBeil_ = require('../../asset/images/guid/guid-TSCall.svg');
const guidTSCart = require('../../asset/images/guid/guid-TSCart.svg');
const guidTSDish = require('../../asset/images/guid/guid-TSDish.svg');

import FormattedMessage from '@/intl/formatted-message';
import shoppingCartMessage from '../../intl/messages/shopping-cart';
import dishMenuMessages from '../../intl/messages/dish-menu';

const getUrlParam = require('../../helper/dish-helper').getUrlParam;

const DishGuid = React.createClass({
  displayName: 'DishGuid',
  propTypes: {
    gotoNextTips: React.PropTypes.func,
    setClose: React.PropTypes.func,
    dishType: React.PropTypes.object,
    getGuidDetail: React.PropTypes.func,
    omitDishGuidStepNumber: React.PropTypes.number,
  },
  getGuidDetail() {
    const type = this.props.dishType.type;
    const showScan = this.props.dishType.showScan;
    // 扫码点餐出现时
    const scanFunc = this.props.dishType.showScan === true ? '76px' : '10px';
    const scanDesc = this.props.dishType.showScan === true ? '140px' : '85px';
    if (type === 'TS') {
      return (
        <div id="tangshi" style={{ display: 'block' }}>
          <div className="tips_1" key="tips_1" style={{ display: 'block' }}>
            <div className="pos-a guid-add">
              <div className="guid-dish">
                <div className="guid-dish-img ">
                  <img src={guidDish} alt="" />
                </div>
                <div className="guid-dish-content">
                  <div className="guid-dish-menu">&nbsp;</div>
                  <span className="guid-dish-menu"></span>
                  <div className="guid-dish-bottom">
                    <span className="guid-dish-price">&nbsp;</span>
                    <img src={guidAdd} alt="" title="" className="add-img" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pos-a guid-desc">
              <img src={guidTSDish} alt="" style={{ width: '160px' }} /><img src={guidArrow} className="pos-a guid-line" alt="" />
            </div>
          </div>
          <div className="tips_2" key="tips_2" style={{ display: 'none' }} >
            <div className="pos-a o-ta--c guid-func" style={{ bottom: scanFunc }}>
              <img src={guidFunction} alt="" title="" className="" style={{ width: '11px' }} />
              <span className=""><FormattedMessage {...shoppingCartMessage.func} /></span>
            </div>
            <div className="pos-a guid-desc" style={{ bottom: scanDesc }}>
              <img src={guidArrow} className="pos-a guid-line" alt="" /><img src={guidFunction_} alt="" style={{ width: '160px' }} />
            </div>
          </div>
          <div className="tips_3" key="tips_3" style={{ display: 'none' }} >
            <div className="pos-a o-ta--c guid-func" style={{ bottom: scanFunc }}>
              <img src={guidBeil} alt="" title="" className="" style={{ width: '11px' }} />
              <span className=""><FormattedMessage {...dishMenuMessages.serviceBell} /></span>
            </div>
            <div className="pos-a guid-desc" style={{ bottom: scanDesc }}>
              <img src={guidBeil_} alt="" style={{ width: '180px' }} /><img src={guidArrow} className="pos-a guid-line" alt="" />
            </div>
          </div>
          <div className="tips_4" key="tips_4" style={{ display: 'none' }} >
            <div className="pos-a o-ta--c guid-func" style={{ bottom: scanFunc }}>
              <img src={guidCar} alt="" title="" className="guid-func-img" />
              <span className="price">239</span>
              <span className="guid-func-num">9</span>
            </div>
            <div className="pos-a guid-desc" style={{ bottom: scanDesc }}>
              <img src={guidTSCart} alt="" style={{ width: '180px' }} /><img src={guidArrow} className="pos-a guid-line" alt="" />
            </div>
          </div>
        </div>
      );
    }
    if (type === 'WM' && showScan === false) {
      return (
        <div id="kuaican" style={{ display: 'block' }}>
          <div className="tips_1" key="tips_1" style={{ display: 'block' }}>
            <div className="pos-a guid-add">
              <div className="guid-dish">
                <div className="guid-dish-img ">
                  <img src={guidDish} alt="" />
                </div>
                <div className="guid-dish-content">
                  <div className="guid-dish-menu">&nbsp;</div>
                  <span className="guid-dish-menu"></span>
                  <div className="guid-dish-bottom">
                    <span className="guid-dish-price">&nbsp;</span>
                    <img src={guidAdd} alt="" title="" className="add-img" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pos-a guid-desc">
              <img src={guidTxt1_} alt="" style={{ width: '160px' }} /><img src={guidArrow} className="pos-a guid-line" alt="" />
            </div>
          </div>
          <div className="tips_2" key="tips_2" style={{ display: 'none' }}>
            <div className="pos-a o-ta--c guid-func">
              <img src={guidCar} alt="" title="" />
            </div>
            <div className="pos-a guid-desc">
              <img src={guidArrow} className="pos-a guid-line" alt="" style={{ width: '20px' }} />
              <img src={guidTxt4_} alt="" style={{ width: '160px' }} />
            </div>
          </div>
          <div className="tips_3" key="tips_3" style={{ display: 'none' }} >
            <div className="pos-a o-ta--c guid-func">
              <FormattedMessage {...shoppingCartMessage.closeOk} />
            </div>
            <div className="pos-a guid-desc">
              <img src={guidTxt8_} alt="" style={{ width: '230px' }} /><img src={guidArrow} className="pos-a guid-line" alt="" />
            </div>
          </div>
        </div>
      );
    }
    return true;
  },
  setClose() {
    document.getElementById('guidBox').style.display = 'none';
    if (!localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'))) {
      localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'));
    }
  },
  gotoNextTips() {
    const { omitDishGuidStepNumber } = this.props; // 需要忽略的步骤
    const nextBtn = document.getElementById('guid-next');
    const guidBox = document.getElementById('guidBox');
    const changeImg = document.getElementById('changeImg');
    const type = this.props.dishType.type;
    const oriNextTips = (type === 'TS') ?
      document.getElementById('tangshi').childNodes
    :
      document.getElementById('kuaican').childNodes;

    const nextTips = [].slice.call(oriNextTips);
    if (omitDishGuidStepNumber) {
      nextTips.splice(omitDishGuidStepNumber - 1, 1); // 去掉某一项
    }

    for (let i = 0; i < nextTips.length; i++) {
      if (nextTips[i].style.display === 'block') {
        if (i === nextTips.length - 2) {
          changeImg.src = (type === 'WM') ? guidTxt7_ : guidTxt6_;
          changeImg.style.width = (type === 'WM') ? '100px' : '150px';
        }
        if (i === nextTips.length - 1) {
          guidBox.style.display = 'none';
          nextBtn.disable = true;
          if (!localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'))) {
            localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'));
          }
          break;
        }
        nextTips[i].style.display = 'none';
        nextTips[i + 1].style.display = 'block';
        break;
      }
    }
  },
  render() {
    const guidDetail = this.getGuidDetail();

    return (
      <div className="t-c guid" id="guidBox">
        <button className="pos-a o-fz--15 guid-close" onTouchTap={this.setClose}>
          <FormattedMessage {...dishMenuMessages.ignoreStep} />
        </button>
        <button className="pos-a t-c o-ta--c guid-next" onTouchTap={this.gotoNextTips} id="guid-next">
          <img src={guidNext} alt="" style={{ width: '60px', marginTop: '8px' }} id="changeImg" />
        </button>
        {guidDetail}
      </div>
    );
  },
});

module.exports = DishGuid;



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-guid.jsx